import React from 'react';

const NotFound = () => {
    

  const styles = {
    container: {
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
      padding: '20px',
      position: 'relative',
      overflow: 'hidden'
    },
    
    backgroundElements: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      overflow: 'hidden',
      zIndex: 1
    },
    
    floatingShape: {
      position: 'absolute',
      borderRadius: '50%',
      animation: 'float 6s ease-in-out infinite'
    },
    
    shape1: {
      width: '80px',
      height: '80px',
      top: '20%',
      left: '10%',
      animationDelay: '0s'
    },
    
    shape2: {
      width: '120px',
      height: '120px',
      top: '60%',
      right: '15%',
      animationDelay: '2s'
    },
    
    shape3: {
      width: '60px',
      height: '60px',
      bottom: '30%',
      left: '20%',
      animationDelay: '4s'
    },
    
    content: {
      textAlign: 'center',
      maxWidth: '600px',
      width: '100%',
      position: 'relative',
      zIndex: 2,
      padding: '40px 20px'
    },
    
    errorNumber: {
      fontSize: 'clamp(8rem, 15vw, 12rem)',
      fontWeight: '900',
      margin: '0',
      background: 'linear-gradient(45deg, #ff6b6b, #ffd93d)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
      animation: 'glow 2s ease-in-out infinite alternate, bounce 3s ease-in-out infinite',
      textShadow: '0 0 30px rgba(255, 107, 107, 0.5)',
      lineHeight: '1'
    },
    
    title: {
      fontSize: 'clamp(1.5rem, 4vw, 2.5rem)',
      fontWeight: '700',
      margin: '20px 0',
      animation: 'slideInUp 1s ease-out 0.5s both'
    },
    
    subtitle: {
      fontSize: 'clamp(1rem, 2.5vw, 1.25rem)',
      margin: '20px 0 40px',
      opacity: '0.9',
      lineHeight: '1.6',
      animation: 'slideInUp 1s ease-out 0.7s both'
    },
    
    buttonContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '15px',
      alignItems: 'center',
      animation: 'slideInUp 1s ease-out 0.9s both'
    },
    
    button: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '10px',
      padding: '15px 30px',
      fontSize: '16px',
      fontWeight: '600',
      textDecoration: 'none',
      borderRadius: '50px',
      border: 'none',
      cursor: 'pointer',
      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      position: 'relative',
      overflow: 'hidden',
      minWidth: '180px',
      justifyContent: 'center'
    },
    
    primaryButton: {
      background: 'linear-gradient(45deg, #ff6b6b, #ff8e8e)',
      color: 'white',
      boxShadow: '0 8px 25px rgba(255, 107, 107, 0.3)'
    },
    
    secondaryButton: {
      backdropFilter: 'blur(10px)',
      border: '1px solid rgba(128, 128, 128, 0.3)'
    },
    
    icon: {
      fontSize: '80px',
      margin: '20px 0',
      animation: 'spin 4s linear infinite'
    }
  };

  const keyframes = `
    /* Light Theme Styles */
    body.light .not-found-container {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    }
    
    body.light .not-found-content {
      color: white;
    }
    
    body.light .floating-shape {
      background: rgba(255, 255, 255, 0.1);
    }
    
    body.light .secondary-btn {
      background: rgba(255, 255, 255, 0.15);
      color: white;
      border-color: rgba(255, 255, 255, 0.2);
    }
    
    body.light .error-number {
      text-shadow: 0 0 30px rgba(255, 107, 107, 0.5);
    }
    
    /* Dark Theme Styles */
    body.dark .not-found-container {
      background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
    }
    
    body.dark .not-found-content {
      color: #e0e0e0;
    }
    
    body.dark .floating-shape {
      background: rgba(255, 255, 255, 0.05);
    }
    
    body.dark .secondary-btn {
      background: rgba(255, 255, 255, 0.1);
      color: #e0e0e0;
      border-color: rgba(255, 255, 255, 0.1);
    }
    
    body.dark .error-number {
      text-shadow: 0 0 30px rgba(255, 107, 107, 0.3);
    }
    
    /* Default Theme (fallback to light) */
    body:not(.light):not(.dark) .not-found-container {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    }
    
    body:not(.light):not(.dark) .not-found-content {
      color: white;
    }
    
    body:not(.light):not(.dark) .floating-shape {
      background: rgba(255, 255, 255, 0.1);
    }
    
    body:not(.light):not(.dark) .secondary-btn {
      background: rgba(255, 255, 255, 0.15);
      color: white;
      border-color: rgba(255, 255, 255, 0.2);
    }
    
    body:not(.light):not(.dark) .error-number {
      text-shadow: 0 0 30px rgba(255, 107, 107, 0.5);
    }

    @keyframes float {
      0%, 100% { transform: translateY(0) rotate(0deg); }
      50% { transform: translateY(-20px) rotate(180deg); }
    }
    
    @keyframes glow {
      0% { text-shadow: 0 0 20px rgba(255, 107, 107, 0.5), 0 0 40px rgba(255, 107, 107, 0.3); }
      100% { text-shadow: 0 0 30px rgba(255, 107, 107, 0.8), 0 0 60px rgba(255, 107, 107, 0.5); }
    }
    
    @keyframes bounce {
      0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
      40% { transform: translateY(-10px); }
      60% { transform: translateY(-5px); }
    }
    
    @keyframes slideInUp {
      from {
        opacity: 0;
        transform: translateY(30px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
    
    @keyframes spin {
      from { transform: rotate(0deg); }
      to { transform: rotate(360deg); }
    }
    
    @keyframes pulse {
      0%, 100% { transform: scale(1); }
      50% { transform: scale(1.05); }
    }
  `;

  const handleBackClick = () => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = '/';
    }
  };

  const handleHomeClick = () => {
    window.location.href = '/';
  };

  const handleButtonHover = (e) => {
    e.target.style.transform = 'translateY(-3px) scale(1.05)';
    e.target.style.boxShadow = '0 15px 35px rgba(0, 0, 0, 0.2)';
  };

  const handleButtonLeave = (e) => {
    e.target.style.transform = 'translateY(0) scale(1)';
    e.target.style.boxShadow = e.target.classList.contains('primary') 
      ? '0 8px 25px rgba(255, 107, 107, 0.3)' 
      : 'none';
  };

  return (
    <>
      <style>{keyframes}</style>
      <div style={styles.container} className="not-found-container">
        {/* Background floating elements */}
        <div style={styles.backgroundElements}>
          <div style={{...styles.floatingShape, ...styles.shape1}} className="floating-shape"></div>
          <div style={{...styles.floatingShape, ...styles.shape2}} className="floating-shape"></div>
          <div style={{...styles.floatingShape, ...styles.shape3}} className="floating-shape"></div>
        </div>

        <div style={styles.content} className="not-found-content">
          <div style={styles.icon}>🔍</div>
          <h1 style={styles.errorNumber} className="error-number">404</h1>
          <h2 style={styles.title}>Oops! Page Not Found</h2>
          <p style={styles.subtitle}>
            The page you're looking for seems to have wandered off into the digital void. 
            Don't worry, it happens to the best of us!
          </p>
          
          <div style={styles.buttonContainer}>
            <button
              className="primary"
              style={{...styles.button, ...styles.primaryButton}}
              onClick={handleBackClick}
              onMouseEnter={handleButtonHover}
              onMouseLeave={handleButtonLeave}
            >
              ← Go Back
            </button>
            
            <button
              className="secondary-btn"
              style={{...styles.button, ...styles.secondaryButton}}
              onClick={handleHomeClick}
              onMouseEnter={handleButtonHover}
              onMouseLeave={handleButtonLeave}
            >
              🏠 Back to Home
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;